import { PERSISTED_STATE_KEY } from '../config/settings';
import setAuthorizationToken from '../utils/setAuthorizationToken';

export const loadState = () => {  
  try {
    const serializedState = localStorage.getItem(PERSISTED_STATE_KEY);
    if (serializedState === null){
      return undefined;
    }
    const persistedState = JSON.parse(serializedState);
    setAuthorizationToken(persistedState.auth.credentials.access_token)
    return persistedState;
  } catch(e) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(PERSISTED_STATE_KEY, serializedState);
  } catch (e) {
    // Ignore with errors
  }
};

export const deleteState = (state) => {
  try {
    localStorage.removeItem(PERSISTED_STATE_KEY);
  } catch (e) {
    // Ignore with errors
  }
};